import { Component } from "@angular/core";
import { OAuthService } from "app/services/o-auth";
import { Router } from "@angular/router";
import { ApiService } from "app/services/api";
import { AngularFireDatabase } from "angularfire2/database";

@Component({
  templateUrl: './gh-mobile-app-.component.html'
})
export class GhMobileAppComponent {
  constructor() {
  }
}
